module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-14.48cd6a96.png";